import Swiper from "swiper";
import "swiper/css";

export default function carousel(autoHeight = false) {
	const carousel = this.$refs.carousel;
	const swiper = new Swiper(carousel, {
		slidesPerView: 1,
		duration: 300,
		autoHeight: autoHeight,
		loop: true,
	});
	const tail = this.$refs.tail;
	const root = this.$root;
	const button = this.$refs.button || null;
	return {
		modalOpen: false,
		activeSlide: "01",
		tailText: "",
		x: 0,
		y: 0,
		init() {
			swiper.on("slideChange", () => {
				const activeIndex = swiper.realIndex + 1;
				this.activeSlide = activeIndex.toString().padStart(2, "0");
			});

			const elements = root.querySelectorAll("[data-tail]");
			elements.forEach((element) => {
				element.onmouseenter = () => {
					this.tailText = element.getAttribute("data-tail");
				};
				element.onmousemove = (e) => {
					this.reCalcTail(e);
				};
			});

			carousel.onmouseleave = () => {
				this.tailText = "";
			};

			if (button) {
				button.onmouseenter = () => {
					this.tailText = "";
				};
			}
		},
		toggleModal() {
			this.modalOpen = !this.modalOpen;
		},
		next() {
			if (swiper.isEnd) {
				swiper.slideTo(0, 300);
				return;
			}

			swiper.slideNext();
		},
		prev() {
			if (swiper.isBeginning) {
				swiper.slideTo(swiper.slides.length - 1, 300);
				return;
			}
			swiper.slidePrev();
		},
		goTo(target) {
			if (!this.modalOpen) {
				this.modalOpen = true;
			}
			swiper.slideTo(target);
		},
		reCalcTail(e) {
			tail.style.left = e.clientX + "px";
			tail.style.top = e.clientY + "px";
			this.x = e.clientX;
			this.y = e.clientY;
		},
	};
}
